import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';

export const initFacebookPixel = (pixelId) => {
  if (!pixelId) return;

  const advancedMatching = {};
  const options = {
    autoConfig: true,  // Automatically configure the Pixel
    debug: false,      // Set to `true` for debugging
  };

  ReactPixel.init(pixelId, advancedMatching, options);
  ReactPixel.pageView(); // Track the initial page view
};

const FacebookPixelTracker = () => {
    const location = useLocation();
  
    useEffect(() => {
      ReactPixel.pageView();
    }, [location.pathname]);
  
    return null;
};
  
export default FacebookPixelTracker;